export const required = (label) => (v) =>
  v == null || String(v).trim() === '' ? `${label} is required` : '';

export const email = (v) =>
  !v ? '' : /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) ? '' : 'Enter a valid email address';

// India-friendly: optional +91, 10 digits starting 6-9
export const phone = (v) =>
  !v ? '' : /^(\+91[-\s]?)?[6-9]\d{9}$/.test(v.replace(/\s/g, '')) ? '' : 'Enter a valid 10-digit phone number';

export const minLen = (n, label) => (v) =>
  !v ? '' : String(v).length >= n ? '' : `${label} must be at least ${n} characters`;

export const timeHHMM = (v) =>
  !v ? '' : /^([01]?\d|2[0-3]):[0-5]\d$/.test(v) ? '' : 'Use HH:MM format';

export const firstError = (value, rules = []) => {
  for (const rule of rules) {
    const msg = rule(value);
    if (msg) return msg;
  }
  return '';
};
